import { Injectable } from '@angular/core';
import { CustomerAddressCreate, CustomerAddressEntity, CustomerAddressUpdate, GovernorateArea } from '@models';
import { BaseApi } from './_base-api';
import { map, Observable } from 'rxjs';
import { ItemRecord, APIHelper } from '@controladad/ng-base';

@Injectable({
  providedIn: 'root',
})
export class AddressApiService extends BaseApi<CustomerAddressEntity, CustomerAddressCreate, CustomerAddressUpdate> {
  constructor() {
    super('/AdminPanel/CustomerAddress', {
      get: '/AdminPanel/GetCustomerAddresses',
      post: '/AdminPanel/AddAddressForCustomer',
    });
  }

  // @ts-ignore
  override getAll(customerId?: number): Observable<CustomerAddressEntity[]> {
    return http$
      .get<{ addresses: CustomerAddressEntity[] }>(`/AdminPanel/GetCustomerAddresses?CustomerId=${customerId}`)
      .pipe(map((r) => r.addresses));
  }

  override create(model: CustomerAddressCreate) {
    return http$.post<never>(`/AdminPanel/AddAddressForCustomer`, model);
  }

  getGovernorates(): Observable<ItemRecord<number>[]> {
    return super.getAll<GovernorateArea>(undefined, '/App/GetGovernorateList')
      .pipe(map((list) => list.map((g) => ({ label: g.name, value: g.id }))));
  }

  getAreas(governorate: number): Observable<ItemRecord<number>[]> {
    return http$
      .get<{ areas: GovernorateArea[] }>(`/App/GetAreaList?GovernorateId=${governorate}`)
      .pipe(map((r) => r.areas.map((g) => ({ label: g.name, value: g.id }))));
  }

  getById(customerId: number, addressId: number) {
    return http$.get(`/AdminPanel/GetCustomerAddress?customerId=${customerId}&addressId=${addressId}`);
  }

  // @ts-ignore
  override update(model: CustomerAddressUpdate) {
    // Map addressName to name for the API
    const fieldsWithNameMapping = { ...model.updateFields };
    if (fieldsWithNameMapping.name !== undefined) {
      (fieldsWithNameMapping as any).name = fieldsWithNameMapping.name;
      delete fieldsWithNameMapping.name;
    }

    const data = {
        addressId: model.addressId,
        fields: APIHelper.nestValues(fieldsWithNameMapping, false)
    };

    return http$.put<never>(`/AdminPanel/EditAddress`, data);
  }

  // @ts-ignore
  override delete(customerId: number, addressId: number) {
    return http$.delete<never>(`/AdminPanel/DeleteCustomerAddress`, {
      body: { customerId, addressId },
    });
  }
}
